
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calculator, TrendingUp } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CalculatorNavProps {
  className?: string;
}

export const CalculatorNav: React.FC<CalculatorNavProps> = ({ className }) => {
  const location = useLocation();
  
  const isPaymentActive = location.pathname === '/try/payment' || location.pathname === '/try';
  const isReversePitiActive = location.pathname === '/try/reverse-piti';

  const navItems = [
    {
      label: 'Payment',
      path: '/try/payment',
      icon: Calculator,
      active: isPaymentActive,
    },
    {
      label: 'Reverse PITI',
      path: '/try/reverse-piti',
      icon: TrendingUp,
      active: isReversePitiActive,
    },
  ];

  return (
    <nav aria-label="Calculators" className={cn("flex bg-slate-800/50 rounded-lg p-1 border border-border/40", className)}>
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          aria-label={item.label}
          aria-current={item.active ? "page" : undefined}
          className={cn(
            "flex min-h-11 min-w-11 items-center justify-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all",
            item.active
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground hover:bg-slate-700/50"
          )}
        >
          <item.icon className="w-4 h-4" />
          <span className="hidden sm:inline">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default CalculatorNav;
